import type { TourDefinition } from "../types";

export const locationsTour: TourDefinition = {
  id: "locations",
  titleKey: "onboarding.tours.locations.title",
  descriptionKey: "onboarding.tours.locations.description",
  module: "locations",
  estimatedMinutes: 2,
  steps: [
    {
      id: "locations-intro",
      targetSelector: "[data-tour='search-input']",
      titleKey: "onboarding.tours.locations.intro.title",
      descriptionKey: "onboarding.tours.locations.intro.description",
      placement: "bottom",
      navigateTo: "/locations",
      waitForSelector: "[data-tour='search-input']",
    },
    {
      id: "locations-add",
      targetSelector: "[data-tour='create-button']",
      titleKey: "onboarding.tours.locations.add.title",
      descriptionKey: "onboarding.tours.locations.add.description",
      placement: "bottom",
      action: "click",
      actionTarget: "[aria-label='Add Location']",
      highlightPulse: true,
    },
    {
      id: "locations-name",
      targetSelector: "[role='dialog'] input[name='name']",
      titleKey: "onboarding.tours.locations.name.title",
      descriptionKey: "onboarding.tours.locations.name.description",
      placement: "bottom",
      waitForSelector: "[role='dialog']",
    },
    {
      id: "locations-type",
      targetSelector: "[role='dialog']",
      titleKey: "onboarding.tours.locations.type.title",
      descriptionKey: "onboarding.tours.locations.type.description",
      placement: "right",
    },
    {
      id: "locations-save",
      targetSelector: "[role='dialog'] button[type='submit']",
      titleKey: "onboarding.tours.locations.save.title",
      descriptionKey: "onboarding.tours.locations.save.description",
      placement: "top",
      celebration: "checkmark",
    },
  ],
};
